import { useCallback } from "react";
import { useCurrentAccountId } from "@zapier/identity";
import emitUserInteractionEvent, {
  UserInteractionName,
} from "./emitUserInteractionEvent";
import { SERVICE_NAME } from "@zapier/utils";

export enum SetDefaultViewOptions {
  Set = "set",
}

interface EmitOptions {
  optionSelected: SetDefaultViewOptions;
  interactionRawText?: string;
}

export function useEmitSetDefaultViewEvent() {
  const accountId = useCurrentAccountId();

  const emit = useCallback(
    ({ optionSelected, interactionRawText }: EmitOptions) => {
      emitUserInteractionEvent({
        accountId,
        eventAction: "click",
        interactionName: UserInteractionName.SetDefaultView,
        interactionRawText,
        optionSelected,
        systemName: SERVICE_NAME,
      });
    },
    [accountId],
  );

  return {
    emit,
  };
}
